<template>
  <ul class="nav nav-mobile-menu">
    <li class="nav-item">
      <a class="nav-link">
        <span class="no-icon" @click="signOut">LOG OUT</span>
      </a>
    </li>
  </ul>
</template>
<script>
  export default {
    components: {
    },
    methods: {
      signOut() {
        this.$store.dispatch('clearState');
        this.$router.push('/login')
      },
    }
  }
</script>
<style>
</style>
